import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { InitialDataResolver } from 'app/app.resolvers';
import { LayoutComponent } from './layout/layouts/layout.component';
import { PageNotFoundComponent } from './modules/page-not-found/page-not-found.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: '/dashboards/customer' },
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: '/dashboards/customer' },
    // Auth routes for guests
    {
        path: '',
        canMatch: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule) },
            { path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule) },
            { path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule) },
            { path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },
            {path: 'auto-login/:id', loadChildren: () => import('app/modules/auth/auto-login/auto-login.module').then(m => m.AutoLoginModule)},
            { path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.module').then(m => m.AuthSignUpModule) },
            { path: 'esign', loadChildren: () => import('app/modules/auth/esign/esign.module').then(m => m.EsignModule) },
            { path: 'otp/:emailid', loadChildren: () => import('app/modules/auth/otp/otp.module').then(m => m.OtpModule) }
           
        ]
    },


    //Auto-Login
    {
        path: '',
        //canMatch: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [

            { path: 'auto-login/:id', loadChildren: () => import('app/modules/auth/auto-login/auto-login.module').then(m => m.AutoLoginModule) },

        ]
    },



    // Auth routes for authenticated users
    {
        path: '',
        canMatch: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule) },
            { path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.module').then(m => m.AuthUnlockSessionModule) }
          
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            { path: 'home', loadChildren: () => import('app/modules/landing/home/home.module').then(m => m.LandingHomeModule) },
            { path: 'esign', loadChildren: () => import('app/modules/auth/esign/esign.module').then(m => m.EsignModule) },

        ]
    },

    // Admin routes
    {
        path: '',
        canMatch: [AuthGuard],
        canActivate: [AuthGuard],
        component: LayoutComponent,
        runGuardsAndResolvers: 'always',
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            // Dashboards
            {
                path: 'dashboards', children: [
                    { path: 'project', loadChildren: () => import('app/modules/admin/dashboards/project/project.module').then(m => m.ProjectModule) },
                    { path: 'analytics', loadChildren: () => import('app/modules/admin/dashboards/analytics/analytics.module').then(m => m.AnalyticsModule) },
                    { path: 'finance', loadChildren: () => import('app/modules/admin/dashboards/finance/finance.module').then(m => m.FinanceModule) },
                    { path: 'crypto', loadChildren: () => import('app/modules/admin/dashboards/crypto/crypto.module').then(m => m.CryptoModule) },
                    { path: 'customer', loadChildren: () => import('app/modules/customer/customer.module').then(m => m.CustomerModule) },

                ]
            },
              
           
            { path: 'CustomerVerification', loadChildren: () => import('app/modules/CustomerVerification/CustomerVerification.module').then(m => m.CustomerVerificationModule) },
            { path: 'MoslSearch', loadChildren: () => import('app/modules/MoslSearch/MoslSearch.module').then(m => m.MoslSearchModule) },
            { path: 'example', loadChildren: () => import('app/modules/admin/example/example.module').then(m => m.ExampleModule) },
            { path: 'sample', loadChildren: () => import('app/modules/admin/sample/table-list/table-list.module').then(m => m.TableListModule) },
            { path: 'quotation', loadChildren: () => import('app/modules/quotation/quotation.module').then(m => m.QuotationModule) },
            { path: 'partner', loadChildren: () => import('app/modules/partner/partner.module').then(m => m.PartnerModule) },
            { path: 'user', loadChildren: () => import('app/modules/user/user.module').then(m => m.UserModule) },
            { path: 'role', loadChildren: () => import('app/modules/Role/Role.module').then(m => m.RoleModule) },
            { path: 'menu', loadChildren: () => import('app/modules/menu/menu.module').then(m => m.MenuModule) },
            { path: 'mydetail/:id', loadChildren: () => import('app/modules/mydetail/mydetail.module').then(m => m.MydetailModule) },
            { path: 'customercare/:id', loadChildren: () => import('app/modules/customer-care/customer-care.module').then(m => m.customercareModule) },
            { path: 'CustomerVerification/:id', loadChildren: () => import('app/modules/cv/cv.module').then(m => m.CvModule) },
            { path: 'CustomerVerification/:item', loadChildren: () => import('app/modules/CustomerVerification/CustomerVerification.module').then(m => m.CustomerVerificationModule) },
            { path: 'flowprocess', loadChildren: () => import('app/modules/flowprocess/flowprocess.module').then(m => m.FlowprocessModule) },
            { path: 'baseoverheadmargin', loadChildren: () => import('app/modules/fbwbaseFbwbaseoverheadmargin/fbwbaseFbwbaseoverheadmargin.module').then(m => m.FbwbaseFbwbaseoverheadmarginModule) },
            { path: 'contractupload', loadChildren: () => import('app/modules/contractupload/contractupload.module').then(m => m.ContractuploadModule) },
            {
                path: 'PowerBiDashboard',
                loadChildren: () => import('app/modules/powerbi/powerbi.module').then(m => m.PowerbiModule)
            },
             { path: 'MeterReadingList', loadChildren: () => import('app/modules/meter-reading-list/meter-reading-list.module').then(m => m.MeterReadingListModule) },
  { path: 'activitylogreport', loadChildren: () => import('app/modules/activity-log-report/activity-log-report.module').then(m => m.ActivityLogReportModule) },
{ path: 'activitylogreportuser', loadChildren: () => import('app/modules/activity-log-report/activity-log-report.module').then(m => m.ActivityLogReportModule) },
  { path: 'customInvoiceReport', loadChildren: () => import('app/modules/billinvoice-custom/billinvoice-custom.module').then(m => m.BillinvoiceCustomModule) },

            { path: 'flow', loadChildren: () => import('app/modules/flow/flow.module').then(m => m.FlowModule) },

            { path: 'bank', loadChildren: () => import('app/modules/bank/bank.module').then(m => m.BankModule) },
{ path: 'reportmenurights', loadChildren: () => import('app/modules/user/user-menu-right-report/user-menu-right.module').then(m => m.UserMenuRightReportModule) },
            { path: 'usermenurights/:id', loadChildren: () => import('app/modules/user/user-menu-right/user-menu-right.module').then(m => m.UserMenuRightModule) },
            { path: 'usermenurights', loadChildren: () => import('app/modules/user/user-menu-right/user-menu-right.module').then(m => m.UserMenuRightModule) },
            { path: 'switchout', loadChildren: () => import('app/modules/switchout/switchout.module').then(m => m.SwitchoutModule) },
            { path: 'usermenurights/role/:id', loadChildren: () => import('app/modules/user/user-menu-right/user-menu-right.module').then(m => m.UserMenuRightModule) },
            { path: 'newconnections', loadChildren: () => import('app/modules/new-connection/new-connection.module').then(m => m.NewConnectionModule) },

            { path: 'change-password', loadChildren: () => import('app/modules/change-password/change-password.module').then(m => m.ChangePasswordModule) },
            { path: 'config', loadChildren: () => import('app/modules/config-setting/config-setting.module').then(m => m.ConfigSettingModule) },
            { path: 'configUpdate', loadChildren: () => import('app/modules/config-setting/config-setting.module').then(m => m.ConfigSettingModule) },
            { path: 'retailer', loadChildren: () => import('app/modules/retailer-componen/retailer.module').then(m => m.Retailermodule) },
            { path: 'lookup', loadChildren: () => import('app/modules/wholesalecontract-lookUp/wholesalecontract-lookUp.module').then(m => m.WholesalecontractLookUpModule) },
            { path: 'wholesaler', loadChildren: () => import('app/modules/Wholesaler/Wholesaler.module').then(m => m.WholesalerModule) },
            { path: 'emailcredentials', loadChildren: () => import('app/modules/emailcredentials/emailcredentials.module').then(m => m.EmailcredentialsModule) },
            { path: 'paymentterm', loadChildren: () => import('app/modules/paymentterm/paymentterm.module').then(m => m.PaymenttermModule) },
            { path: 'query', loadChildren: () => import('app/modules/query/query.module').then(m => m.QueryModule) },
            { path: 'paymentgroup', loadChildren: () => import('app/modules/payment-group/payment-group.module').then(m => m.PaymentGroupModule) },
            { path: 'billing', loadChildren: () => import('app/modules/billing/billing.module').then(m => m.BillingModule) },
            { path: 'dashboards/customer', loadChildren: () => import('app/modules/group-cv/group-cv.module').then(m => m.GroupCvModule) },
            { path: 'dashboards/customer/:customertype', loadChildren: () => import('app/modules/group-cv/group-cv.module').then(m => m.GroupCvModule) },
            { path: 'visibility', loadChildren: () => import('app/modules/visiblitiy-group/visiblitiy-group.module').then(m => m.VisiblitiyGroupModule) },
            { path: 'paymentmanagement', loadChildren: () => import('app/modules/direct-debit/direct-debit.module').then(m => m.DirectDebitModule) },
            { path: 'paymentallocation', loadChildren: () => import('app/modules/directdebit-payment/directdebit-payment.module').then(m => m.DirectdebitPaymentModule) },
            { path: 'groupdetail', loadChildren: () => import('app/modules/group-detail/group-detail.module').then(m => m.GroupDetailModule) },
            { path: 'commissionstatement', loadChildren: () => import('app/modules/commission/commission-statement/commission-statement.module').then(m => m.CommissionStatementModule) },
            { path: 'commission', loadChildren: () => import('app/modules/commission/commission.module').then(m => m.CommissionModule) },
            { path: 'commissionstatement/:id', loadChildren: () => import('app/modules/commission/commission-detail/commission-detail.module').then(m => m.CommissionDetailModule) },
            { path: 'changerequest', loadChildren: () => import('app/modules/change-request/change-request.module').then(m => m.ChangeRequestModule) },
            { path: 'billingdiscrepancyaddresslist', loadChildren: () => import('app/modules/billing-discrepancy-address-list/billing-discrepancy-address-list.module').then(m => m.BillingDiscrepancyAddressListModule) },
            { path: 'verifyingbillingaddresslist', loadChildren: () => import('app/modules/verifying-billing-address-list/verifying-billing-address-list.module').then(m => m.VerifyingBillingAddressListModule) },
            { path: 'monthlypaymentschedule', loadChildren: () => import('app/modules/monthly-payment-plan-schedule/monthly-payment-plan-schedule.module').then(m => m.MonthlyPaymentPlanScheduleModule) },
            { path: 'renewalmoduledashboard', loadChildren: () => import('app/modules/Renewal-Module-Dashboard/Renewal-Module-Dashboard.module').then(m => m.RenewalModuleDashboardModule) },
            { path: 'console', loadChildren: () => import('app/modules/console/console.module').then(m => m.ConsoleModule) },
            { path: 'stopbilling', loadChildren: () => import('app/modules/stop-billing/stop-billing.module').then(m => m.StopBillingModule) },

            //{path: 'CustomerVerification/globalsearch/:AccountId/:CoreSPID/:SPID', loadChildren: () => import('app/modules/CustomerVerification/CustomerVerification.module').then(m => m.CustomerVerificationModule)            },
            { path: 'commondetail', loadChildren: () => import('app/modules/Common-details/Common-details.module').then(m => m.CommonDetailsModule) },

            // {path: 'retailer1', loadChildren: () => import('app/modules/admin/Retailer/retailer.module').then(m => m.Retailermodule)}
            { path: 'verifyingbillingaddresslist', loadChildren: () => import('app/modules/verifying-billing-address-list/verifying-billing-address-list.module').then(m => m.VerifyingBillingAddressListModule) },
            { path: 'paysuitepaymentrequest', loadChildren: () => import('app/modules/paysuite-payment-request/paysuite-payment-request.module').then(m => m.PaysuitePaymentRequestModule) },


            { path: 'uploadcalllog', loadChildren: () => import('app/modules/upload-call-log/upload-call-log.module').then(m => m.UploadCallLogModule) }, { path: 'meterimagevalidationdashboard', loadChildren: () => import('app/modules/meter-image-validation-dashboard/meter-image-validation-dashboard.module').then(m => m.MeterImageValidationDashboardModule) },
            { path: 'multiplereversebill', loadChildren: () => import('app/modules/multiple-reverse-bill/multiple-reverse-bill.module').then(m => m.MultipleReverseBillModule) },
            { path: 'uploadpayment', loadChildren: () => import('app/modules/upload-payment-csv/upload-payment-csv.module').then(m => m.UploadPaymentCsvModule) },
            { path: 'uploadmeterreads', loadChildren: () => import('app/modules/upload-meter-reads/upload-meter-reads.module').then(m => m.UploadMeterReadsModule) },
            { path: 'custominvoice', loadChildren: () => import('app/modules/custom-invoice/custom-invoice.module').then(m => m.CustomInvoiceModule) },
            { path: 'DebtLetter', loadChildren: () => import('app/modules/debt-letter-detail/debt-letter-detail.module').then(m => m.DebtLetterDetailModule) },
            { path: 'ageddebtreporting', loadChildren: () => import('app/modules/aged-debt-reporting/aged-debt-reporting.module').then(m => m.AgedDebtReportingModule) },
            { path: 'monthlybillingreport', loadChildren: () => import('app/modules/monthly-billing-report/monthly-billing-report.module').then(m => m.MonthlyBillingReportModule) },
             { path: 'spidreport', loadChildren: () => import('app/modules/spid-report/spid-report.module').then(m => m.SpidReportModule) },
            { path: 'generalreport', loadChildren: () => import('app/modules/general-report/general-report.module').then(m => m.GeneralReportModule) },
            { path: 'newcustomer', loadChildren: () => import('app/modules/new-customer/new-customer.module').then(m => m.NewCustomerModule) },
            { path: 'emailaddresscleanup', loadChildren: () => import('app/modules/payment-address-update/payment-address-update.module').then(m => m.PaymentAddressUpdateModule) },
            { path: 'balance-transfer', loadChildren: () => import('app/modules/balance-transfer/balance-transfer.module').then(m => m.BalanceTransferModule) },    { path: 'valytica', loadChildren: () => import('app/modules/group-cv/valytica-report/valytica-report.module').then(m => m.ValyticaReportModule) },

          { path: 'updatecustomer', loadChildren: () => import('app/modules/update-customer/update-customer.module').then(m => m.UpdateCustomerModule) },
             { path: 'groupwisereport', loadChildren: () => import('app/modules/group-wise-report/group-wise-report.module').then(m => m.GroupWiseReportModule) },
    
        ]
    },
    {
        path: 'norights',
        component: LayoutComponent,

        children: [
            // Dashboards

            {
                path: 'norights',
                loadChildren: () =>
                    import(
                        'app/modules/admin/sample/table-list/table-list.module'
                    ).then((m) => m.TableListModule),
            }

            // {path: 'retailer1', loadChildren: () => import('app/modules/admin/Retailer/retailer.module').then(m => m.Retailermodule)}
        ],
    },

    { path: '**', component: PageNotFoundComponent },
];
